import React, { Fragment, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import s from './ModelThresholds.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import ModelThreshold from './ModelThreshold';

const ModelThresholdsListTable = ({
  setEditHandler,
  selectedModelThresholdId,
  selectedModelCategoryId,
  saveModelThreshold,
  modelThreshold,
  describeModelThreshold,
  changeModelThreshold,
  paginatedData = [],
  flowSequences,
  modelComponentPositions,
  disableMode,
  disableModeHandler,
  UpdateAllowed,
  DeleteAllowed,
  removeThreshold,
  isOwner
}) => {
  const fetchDataHandler = ModelThresholdId => {
    setEditHandler(ModelThresholdId);
    disableModeHandler(true);
    describeModelThreshold(ModelThresholdId, selectedModelCategoryId);
  };

  const cancelHandler = () => {
    setEditHandler(-1);
    disableModeHandler(false);
  };
  useLayoutEffect(() => {
    if (disableMode) {
      const scrollPos = window.scrollY + window.innerHeight;
      window.scrollTo(0, scrollPos);
    }
  }, [disableMode]);
  const editModelContent = (
    <ModelThreshold
      ModelThresholdId={selectedModelThresholdId}
      ModelCategoryId={selectedModelCategoryId}
      saveModelThreshold={saveModelThreshold}
      modelThreshold={modelThreshold}
      changeModelThreshold={changeModelThreshold}
      flowSequences={flowSequences}
      modelComponentPositions={modelComponentPositions}
      cancelHandler={cancelHandler}
    />
  );

  let editorMain = (
    <tr>
      <td colSpan="12">{editModelContent}</td>
    </tr>
  );

  let newRowClass = modelThreshold.showAddEditScreen && selectedModelThresholdId === 0 ? s.newRow : '';
  return (
    <div className={s.wsTableContainer}>
      <Table className={s.wsTable}>
        <thead>
          <tr>
            <th>
              <FormattedMessage id="general.sequence" defaultMessage="Sequence" />
            </th>
            <th>
              <FormattedMessage id="general.component" defaultMessage="Component" />
            </th>
            <th className="d-none d-md-table-cell">
              <FormattedMessage id="threshold.thresholdUnitOfMeasure" defaultMessage="Unit Of Measure" />
            </th>
            <th className="d-none d-md-table-cell">
              <span>
                <FormattedMessage id="threshold.thresholdLowLow" defaultMessage="Low Low" />
              </span>
            </th>
            <th className="d-none d-md-table-cell">
              <span >
                <FormattedMessage id="threshold.thresholdLow" defaultMessage="Low" />
              </span>
            </th>
            <th className="d-none d-md-table-cell">
              <span >
                <FormattedMessage id="threshold.thresholdOpLow" defaultMessage="Op Low" />
              </span>
            </th>
            <th className="d-none d-md-table-cell">
              <span >
                <FormattedMessage id="threshold.thresholdOpHigh" defaultMessage="Op High" />
              </span>
            </th>
            <th className="d-none d-md-table-cell">
              <span >
                {' '}
                <FormattedMessage id="threshold.thresholdHigh" defaultMessage="High" />
              </span>
            </th>
            <th className="d-none d-md-table-cell">
              <span>
                <FormattedMessage id="threshold.thresholdHighHigh" defaultMessage="High High" />
              </span>
            </th>
            <th className="d-none d-md-table-cell">
              <span>
                <FormattedMessage id="threshold.editable" defaultMessage="Editable" />
              </span>
            </th>
            {isOwner && (UpdateAllowed || DeleteAllowed) && <th></th>}
          </tr>
        </thead>
        <tbody>
          {paginatedData.map(n => {
            return (
              <Fragment key={n.ModelThresholdId}>
                <tr key={n.ModelThresholdId} data-unittest="thresholdsData">
                  <td>{n.FlowSequence}</td>
                  <td>{n.ModelComponentName}</td>
                  <td className="d-none d-md-table-cell">{n.UnitOfMeasure}</td>
                  <td className="d-none d-md-table-cell">
                    <span className={s.red}>{n.Min}</span>
                  </td>
                  <td className="d-none d-md-table-cell">
                    <span className={s.orange}>{n.CriticalLow}</span>
                  </td>
                  <td className="d-none d-md-table-cell">
                    <span className={s.green}>{n.Low}</span>{' '}
                  </td>
                  <td className="d-none d-md-table-cell">
                    <span className={s.green}>{n.High}</span>{' '}
                  </td>
                  <td className="d-none d-md-table-cell">
                    <span className={s.orange}>{n.CriticalHigh}</span>
                  </td>
                  <td className="d-none d-md-table-cell">
                    <span className={s.red}>{n.Max}</span>
                  </td>
                  <td className="d-none d-md-table-cell">
                    {n.IsEditable ? (
                      <span className={s.green}><FormattedMessage id="common.yes" defaultMessage="Yes" /></span>
                    ) : (
                      <span className={s.red}><FormattedMessage id="common.no" defaultMessage="No" /></span>
                    )}
                  </td>
                  {isOwner && (UpdateAllowed || DeleteAllowed) && (
                    <td className={s.btnCol}>
                      {UpdateAllowed && (
                        <Button
                          variant="outline-secondary"
                          className={s.changeButton}
                          href="#"
                          onClick={fetchDataHandler.bind(this, n.ModelThresholdId)}
                          disabled={disableMode}
                          data-unittest="btnChange"
                        >
                          <FormattedMessage id="common.ledit" defaultMessage="Edit" />
                        </Button>
                      )}
                      {DeleteAllowed && (
                        <Button
                          variant="outline-secondary"
                          className={s.changeButton}
                          href="#"
                          onClick={() => removeThreshold(n.ModelThresholdId)}
                          disabled={disableMode}
                          data-unittest="btnRemove"
                        >
                          <FormattedMessage id="common.remove" defaultMessage="Remove" />
                        </Button>
                      )}
                    </td>
                  )}
                </tr>
                {modelThreshold.showAddEditScreen && selectedModelThresholdId === n.ModelThresholdId && editorMain}
              </Fragment>
            );
          })}
        </tbody>
      </Table>
      <div className={newRowClass}>
        {modelThreshold.showAddEditScreen && selectedModelThresholdId === 0 && editModelContent}
      </div>
    </div>
  );
};

ModelThresholdsListTable.propTypes = {
  describeModelThreshold: PropTypes.func.isRequired,
  changeModelThreshold: PropTypes.func.isRequired
};

export default injectIntl(ModelThresholdsListTable);
